import React from 'react'

interface SkIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const SkIcon = (props: SkIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_94766)">
        <path d="M1 1.19922H21V21.1992H1V1.19922Z" fill="#EE1C25" />
        <path d="M1 1.19922H21V14.5312H1V1.19922Z" fill="#0B4EA2" />
        <path d="M1 1.19922H21V7.86719H1V1.19922Z" fill="white" />
        <path
          d="M8.93359 16.6484C7.14062 15.7891 4.57812 14.0703 4.57812 10.6797C4.57812 7.28906 4.73828 5.75 4.73828 5.75H13.1289C13.1289 5.75 13.293 7.28906 13.293 10.6797C13.293 14.0703 10.7227 15.7852 8.93359 16.6484Z"
          fill="white"
        />
        <path
          d="M8.93359 16.1992C7.28906 15.4062 4.9375 13.8359 4.9375 10.7227C4.9375 7.60938 5.08594 6.19922 5.08594 6.19922H12.7813C12.7813 6.19922 12.9297 7.61328 12.9297 10.7227C12.9297 13.832 10.5781 15.4102 8.93359 16.1992Z"
          fill="#EE1C25"
        />
        <path
          d="M9.29297 9.91016C9.73828 9.91797 10.6094 9.93359 11.3828 9.67578C11.3828 9.67578 11.3594 9.94922 11.3594 10.2734C11.3594 10.5977 11.3828 10.8711 11.3828 10.8711C10.7028 10.6838 9.99757 10.6047 9.29297 10.6367V12.3555H8.58984V10.6367C7.88525 10.6047 7.17999 10.6838 6.5 10.8711C6.5 10.8711 6.52344 10.5977 6.52344 10.2734C6.52344 9.94922 6.5 9.67578 6.5 9.67578C7.27734 9.93359 8.14453 9.91797 8.58984 9.91016V8.82812C8.0296 8.81439 7.47104 8.89494 6.9375 9.06641C6.9375 9.06641 6.95703 8.79297 6.95703 8.46875C6.95703 8.14453 6.9375 7.86719 6.9375 7.86719C7.60156 8.08984 8.18359 8.10937 8.58594 8.10156C8.56641 7.42187 8.36719 6.5625 8.36719 6.5625C8.36719 6.5625 8.77734 6.59375 8.94141 6.59375C9.10547 6.59375 9.51563 6.5625 9.51563 6.5625C9.51563 6.5625 9.31641 7.42188 9.29297 8.10547C9.85308 8.12197 10.4119 8.04271 10.9453 7.87109C10.9453 7.87109 10.9258 8.14453 10.9258 8.46875C10.9258 8.79297 10.9453 9.06641 10.9453 9.06641C10.2813 8.84375 9.69922 8.82812 9.29297 8.83203V9.91016Z"
          fill="white"
        />
        <path
          d="M8.9375 12.168C8.10938 12.168 7.66406 13.3164 7.66406 13.3164C7.66406 13.3164 7.41797 12.7695 6.74219 12.7695C6.28516 12.7695 5.94922 13.1797 5.73438 13.5586C6.56641 14.8789 7.89453 15.6953 8.9375 16.1992C9.98047 15.6953 11.3086 14.8789 12.1406 13.5547C11.9258 13.1797 11.5898 12.7734 11.1328 12.7734C10.457 12.7734 10.2109 13.3203 10.2109 13.3203C10.2109 13.3203 9.76563 12.168 8.9375 12.168Z"
          fill="#0B4EA2"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_94766">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
